import { ReactElement } from 'react';
import Button from '../../../ui/button/button';
import { BUTTON_VARIANTS } from '../../../constants/button-variants';
import { MATERIAL_VIEWS } from '../../../constants/search';
import translation from '../../../languages';
import cn from '../../../utils/classnames';
import FavoritesMaterialCard from '../../favorites/components/favorites-material-card/favorites-material-card';
import FavoritesPageContext from '../../favorites/contexts/favorites-page-context';
import useFavoritesPageState from '../../favorites/hooks/use-favorites-page-state';
import useFavorites from './hooks/use-favorites';
import './favorites.scss';

type FavoritesProps = TranslationProps & { className?: string };

const Favorites = ({ t, className }: FavoritesProps): ReactElement => {
    const { materials, hasMoreToFetch, onFetchNextPage, onRemove } = useFavorites();

    const favoritesPageState = useFavoritesPageState();

    const wrapperClassNames = cn('favorites-wrapper d-none d-lg-block', className);

    return (
        <FavoritesPageContext.Provider value={favoritesPageState}>
            <div className={wrapperClassNames}>
                {materials.length > 0 && (
                    <>
                        <h4 className='title'>{t('cart.favoritesSection.title')}</h4>

                        <div className='favorites-list d-flex flex-wrap'>
                            {materials.map((item, index) => (
                                <FavoritesMaterialCard
                                    key={item.id}
                                    item={item}
                                    index={index}
                                    internalPath='sp'
                                    viewMode={MATERIAL_VIEWS.LIST}
                                    onRemove={onRemove}
                                />
                            ))}
                        </div>

                        {hasMoreToFetch && (
                            <Button
                                className='fetch-more-btn'
                                variant={BUTTON_VARIANTS.YELLOW}
                                onClick={onFetchNextPage}
                            >
                                {t('common.showMore')}
                            </Button>
                        )}
                    </>
                )}
            </div>
        </FavoritesPageContext.Provider>
    );
};

const translate = translation(['cart', 'common']);

export default translate(Favorites);
